import { Stack, useTheme } from "@mui/material";
import { Button, FoodsIcon } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import type { TemplateDetail } from "src/api/client-api/actionPlanTemplates/useActionPlanTemplate";
import { URLHandler } from "src/services/URLHandler";
import { SettingsPageHeader } from "../components/SettingsPageHeader";

type Props = {
    template: TemplateDetail;
    valid: boolean;
    busy: boolean;
    onSave: () => void;
    onDone: () => void;
};

export const TemplateEditorHeader = (props: Props) => {
    const { template, valid, busy, onSave, onDone } = props;

    const { t } = useTranslation();
    const theme = useTheme();

    const listUrl = URLHandler.settings.configurationPath("platform-setup", "action-plan-templates");

    return (
        <Stack direction={{ xs: "column", lg: "row" }} justifyContent="space-between" gap={theme.spacing(2)}>
            <SettingsPageHeader
                title={template.name}
                subtitle={t(
                    "settings.action_plan_templates.detail.description",
                    "Set up your action plan template and add actions to it.",
                )}
                breadcrumbs={[
                    { label: t("settings.platform.title", "Platform"), to: URLHandler.settings.configuration() },
                    {
                        label: t("settings.platform.platform_setup.title", "Platform setup"),
                        to: URLHandler.settings.configurationPath("platform-setup"),
                    },
                    { label: t("settings.action_plan_templates.title", "Action plan templates"), to: listUrl },
                    { label: template.name, to: `${listUrl}/${template.id}` },
                ]}
            />
            <Stack direction="row" gap={theme.spacing(1)} alignItems="flex-start">
                <Button
                    variant="validate"
                    disabled={!valid || busy}
                    onClick={() => onSave()}
                    startIcon={<FoodsIcon icon="save" size={1} />}
                >
                    {template.status === "draft" ?
                        t("settings.action_plan_templates.editor.save_draft", "Save draft")
                    :   t("settings.action_plan_templates.editor.save_changes", "Save changes")}
                </Button>
                <Button variant="secondary" disabled={busy} onClick={() => onDone()}>
                    {t("settings.action_plan_templates.editor.done", "Done editing")}
                </Button>
            </Stack>
        </Stack>
    );
};
